import { Button, Checkbox, FormControlLabel, Snackbar, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState, useRef } from 'react'
import { useParams, useHistory } from "react-router-dom";
import { objectAsParams } from '../../../../helpers';
import Http from '../../../../Http';
import ManifiestosCliente from './ManifiestosCliente';

let queryParams = {};
export default function ManifiestosClis() {
  const [ExcelFile, setExcelFile] = useState(null);
  const [Loading, setLoading] = useState(false);
  const Params = useParams();
  const History = useHistory();
  const [Snack, setSnack] = useState({ visible: false, msg: null });
  const [Cliente, setCliente] = useState({});
  const [Clientes, setClientes] = useState([]);
  const tablaManifiestosRef = useRef(null);


  useEffect(() => {
    if (Params.id) getCli(Params.id);
    else setCliente({});
  }, [Params])

  const getClis = async () => {
    try {
      let Res = await Http.get(`cliente/form/manifiestos?${objectAsParams(queryParams)}`);
      if (!Res.error) {
        setClientes(Res.data.clientes);
      }
    } catch (error) {
      console.log('Error en getClis ', error);
    }
  }

  const getCli = async (id) => {
    let Res = await Http.get(`cliente-manifiesto/${id}/uso-manifiestos`);
    if (!Res.error) {
      setCliente(Res.data);
    }
  }

  const onFileChange = (event) => {
    // console.log(event.target.files);
    setExcelFile(event.target.files[0]);
  }

  const onUploadExcel = async () => {
    setLoading(true);
    try {
      let data = new FormData();
      data.append('excel', ExcelFile);
      let Res = await Http.post(`cliente-manifiesto/${Cliente.id}/manifiestos`, data);
      if (!Res.error) {
        setExcelFile(null);
        setSnack({ visible: true, msg: 'Manifiestos cargados' });
        tablaManifiestosRef.current.loadTable();
      }
      else {
        setSnack({ visible: true, msg: 'Error al subir el archivo, verificar que el contenido sea correcto' });
      }
    } catch (error) {
      console.error(error);
      setSnack({ visible: true, msg: 'Error al cargar el Excel' });
    }
    setLoading(false);
  }

  const onClienteManifiestoChange = async (e) => {
    try {
      let data = { id: Cliente.id, cliente_manifiestos: e.target.checked };
      let Res = await Http.post(`cliente/save`, data);
      if (!Res.error) {
        console.log('saved', Res.data.data);
        setCliente({ ...Cliente, cliente_manifiestos: Res.data.data.cliente_manifiestos })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const onClienteChange = async (id, val) => {
    if (val && val.length > 2);
    queryParams[id] = val;
    getClis();
  }

  const onSelectCliente = (e, val) => {
    if (val && val.id) {
      History.push(`/Manifiestos/${val.id}`);
    } else {
      History.push(`/Manifiestos`);
    }
  }

  return (
    <div style={{ padding: 20, backgroundColor: '#fff' }}>

      <div style={{ textAlign: 'center', margin: 10, display: 'flex', justifyContent: 'center' }}>
        <Autocomplete
          options={Clientes}
          getOptionLabel={(option) => option.cliente}
          style={{ width: 300 }}
          onChange={onSelectCliente}
          renderInput={(params) => <TextField {...params} style={{ width: '80%' }} label="Cliente" variant="outlined" onChange={(e) => onClienteChange('cl', e.target.value)} />}
        />
        <Autocomplete
          options={Clientes}
          getOptionLabel={(option) => option.cliente}
          style={{ width: 300 }}
          onChange={onSelectCliente}
          renderInput={(params) => <TextField {...params} style={{ width: '100%' }} label="Razón social" variant="outlined" onChange={(e) => onClienteChange('rs', e.target.value)} />}
        />
      </div>

      <hr />

      {
        Cliente.id && (
          <div>
            <h4 style={{textAlign: 'center'}}>{Cliente.cliente_rsocial}</h4>
            <div>
              <h4>Uso de manifiestos</h4>
              <FormControlLabel
                control={<Checkbox checked={Cliente.cliente_manifiestos || false} onChange={onClienteManifiestoChange} name="antoine" />}
                label="Usar manifiestos"
              />
            </div>

            <hr />

            <div>
              <h4>Cargar manifiestos</h4>
              <input type='file' onChange={onFileChange} />
              <br />
              <br />
              <Button
                disabled={!ExcelFile || Loading}
                variant="contained"
                color='primary'
                onClick={onUploadExcel}
              >
                Subir excel
              </Button>
            </div>

            <hr />

            <ManifiestosCliente idCliente={Cliente.id} ref={tablaManifiestosRef} />

          </div>

        )
      }

      <Snackbar
        open={Snack.visible}
        autoHideDuration={6000}
        onClose={() => setSnack({ visible: false, msg: '' })}
        message={Snack.msg}
      />
    </div>
  )
}
